import React from 'react'

import { Player } from 'video-react'

import {
    EuiTitle,
    EuiText,
    EuiIcon,
    EuiPanel
  } from '@elastic/eui'

import { OutboundLink } from 'gatsby-plugin-gtag'

require('../../Layout/chrome/assets/video.css')

function VideoCard() {
  return (
    <EuiPanel paddingSize="m">
        <EuiTitle size="s"><h4>Motion Detection Setup</h4></EuiTitle>
        <Player>
            <source src="https://wiki.instar.com/videos/Firmware_ueberschreiben_bei_INSTAR_HD_Kameras_ueber_eine_serielle_Verbindung.mp4" />
        </Player>
        <EuiText>
            <p>In diesem Video zeigen wir Ihnen wie Sie über die serielle Schnittstelle Ihre INSTAR HD IP Kamera wiederbeleben können sofern Sie ein fehlerhaftes Firmwareupdate hatten weil z.B. die Stromverbindung unterbrochen wurde.</p>
            <p>Im Video zeigen wir Schritt für Schritt wie Sie die vorhandene Firmware durch die aktuelle überspielen können. Auf <OutboundLink href="https://www.youtube.com/watch?v=AV2vr5X7Re8" target="_blank" rel="noopener noreferrer">Youtube ansehen <EuiIcon type="popout" /></OutboundLink></p>
        </EuiText>
    </EuiPanel>
  );
}

export default VideoCard